export default __webpack_public_path__ + "static/media/3.a764e2c8.svg";